import React from 'react';
import { connect } from 'react-redux';
import { selectModuleItem } from 'manage-modules/redux/manageModulesActions';
import MediaListItem from 'components/MediaListItem';

const ModuleItemsListItem = props => <MediaListItem {...props} />;

const mapStateToProps = (state, ownProps) => ({
  selected: state.manageModules.moduleCard.selectedItemIds.includes(
    ownProps.media.id,
  ),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelected: value => {
    dispatch(selectModuleItem(value, ownProps.media.id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  ModuleItemsListItem,
);
